import { Component, OnInit, ViewChild } from '@angular/core';
import { AbstractControl, FormControl, FormGroup, Validators } from '@angular/forms';
import { IonContent, NavController, NavParams } from '@ionic/angular';
import { AuthenticationService } from 'src/app/services/authentication/authentication.service';
import { ConfigService } from 'src/app/services/config/config.service';
import { EventsService } from 'src/app/services/event/event.service';
import { SuccessMessageService } from 'src/app/services/message-provider/success-message.service';
import { UtilsService } from 'src/app/services/utils/utils.service';
import { Navigator } from 'src/app/services/routing/navigator';
import { PASSWORD_PATTERN } from 'src/app/services/customFormValidators';

@Component({
  selector: 'app-reset-password-verify-third-step',
  templateUrl: './reset-password-verify-third-step.component.html',
  styleUrls: ['./reset-password-verify-third-step.component.scss'],
})
export class ResetPasswordVerifyThirdStepComponent implements OnInit {
  @ViewChild(IonContent, { static: false }) content: IonContent;

  public error: any = null;

  public step3Form: FormGroup;

  public loginUrl: string;
  public email: string;
  public pin: string;
  public customerId: string;

  public passwordGroup: AbstractControl;
  public newPassword: AbstractControl;
  public confirmPassword: AbstractControl;

  public updateSuccess: boolean = false;

  public showPassword:boolean;
  public showConfirmPassword:boolean;
  public showForm:boolean = true;
  
  constructor(
      public navCtrl: NavController,
      public navParams: NavParams,
      public authenticationProvider: AuthenticationService,
      public successMessageProvider: SuccessMessageService,
      public config: ConfigService,
      public utils: UtilsService,
      private events: EventsService,
      public navigator: Navigator
  ) {
      this.successMessageProvider.clearMessage();

      this.email = this.navParams.get("email");
      this.pin = this.navParams.get("pin");
      this.customerId = this.navParams.get("customerId");

      this.loginUrl = `${this.config.getConfig().LOBBY_URL}?r=0#load-dialog=login`;
  }

  ngOnInit() {        
      this.step3Form = new FormGroup({
          email: new FormControl(''),
          pin: new FormControl(''),
          customerId: new FormControl(''),
          passwordGroup: new FormGroup({
              newPassword: new FormControl('', [Validators.required, Validators.minLength(8), Validators.pattern(PASSWORD_PATTERN)]),
              confirmPassword: new FormControl('', [Validators.required, Validators.minLength(8), Validators.pattern(PASSWORD_PATTERN)]),
          }, this.passwordMatchValidator),
      });

      this.passwordGroup = this.step3Form.get('passwordGroup');
      this.newPassword = this.passwordGroup.get('newPassword');
      this.confirmPassword = this.passwordGroup.get('confirmPassword');

      this.step3Form.get("email").setValue(this.email);
      this.step3Form.get("pin").setValue(this.pin);
      this.step3Form.get("customerId").setValue(this.customerId);
  }

  onSubmit() {
      this.successMessageProvider.clearMessage();
      this.error = null;
      this.step3Form.value.clientapp = this.config.getClientApp();
      this.authenticationProvider.callResetPasswordByEmail(this.step3Form.value).subscribe(
          (response: any) => {
              if (response && !!response.result) {
                  this.updateSuccess = true;
                  this.successMessageProvider.setMessage("Your password has been reset.");
                  this.events.publish("event:password:reset", {});
                  this.content.scrollToTop(10);
              }
          },
          (error) => {
            switch (error.getErrorCode().toUpperCase()) {
              case 'INVALID_PIN_NUMBER':
                  error.setErrorMessage('PIN does not match.');
                  break;
              case 'SECURE_MAX_ATTEMPTS_REACHED':
                  error.setErrorMessage(error.getErrorMessage());
                  this.showForm = false;
                  break;
              case 'CURRENT_PASS_NO_MATCH':
                  error.setErrorMessage("Your new password can not match your current password.");
                  break;
              default:
                  this.showForm = true;
                  error.setErrorMessage('An error occurred when resetting your password. Please try again.')
                  break;
          }
              this.error = error;
              this.content.scrollToTop(10);
          }
      );
  }

  passwordMatchValidator(group: FormGroup) {
      return group.get('newPassword').value === group.get('confirmPassword').value ? null : { 'mismatch': true };
  }

  hidePassword(): void{
    this.showPassword = false;
  }

  unhidePassword(): void{
    this.showPassword = true;
  }

  hideConfirmPassword(): void{
    this.showConfirmPassword = false;
  }

  unhideConfirmPassword(): void{
    this.showConfirmPassword = true;
  }
}
